/* Calendly-Buchungen tragen bisher keine Quelle — im Produktions-Cockpit ist
   `Quelle` bei 0 von 43 Vorgaengen gefuellt. Dieses Skript haengt die
   Meta-Parameter der Landingpage an jeden Calendly-Link, damit sie im
   Buchungsdatensatz landen und per Webhook auswertbar werden.

   Laeuft per `defer`, also nach dem Parsen und lange bevor Calendlys widget.js
   per IntersectionObserver nachgeladen wird — `data-url` ist dann schon gepatcht. */
(function () {
  var FELDER = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var SPEICHER = 'gbCalTracking';

  function gemerkt() {
    try { return JSON.parse(sessionStorage.getItem(SPEICHER)) || {}; }
    catch (e) { return {}; }
  }

  function merken(daten) {
    try { sessionStorage.setItem(SPEICHER, JSON.stringify(daten)); }
    catch (e) { /* Private Mode: dann gilt nur diese Seite */ }
  }

  function marketingErlaubt() {
    try { return window.Shopify.customerPrivacy.marketingAllowed(); }
    catch (e) { return false; }
  }

  var seite = new URLSearchParams(location.search);
  var daten = gemerkt();
  var neu = false;

  FELDER.forEach(function (k) {
    if (seite.get(k)) { daten[k] = seite.get(k); neu = true; }
  });

  /* Die Klick-ID wird immer gemerkt, aber erst an Calendly uebergeben, wenn
     Marketing-Consent vorliegt — von dort geht sie spaeter an Meta. Consentmo
     laedt asynchron, deshalb unten der zweite Versuch nach `visitorConsentCollected`. */
  var fbclid = seite.get('fbclid');
  if (fbclid && !daten._fbc) {
    daten._fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    neu = true;
  }
  if (neu) merken(daten);

  function anwenden() {
    var uebergabe = {};
    FELDER.forEach(function (k) { if (daten[k]) uebergabe[k] = daten[k]; });

    /* `salesforce_uuid` ist Calendlys einziges freies Passthrough-Feld, das im
       Webhook zurueckkommt — dort reist die Klick-ID im fbc-Format mit. */
    if (daten._fbc && marketingErlaubt()) uebergabe.salesforce_uuid = daten._fbc;
    if (!Object.keys(uebergabe).length) return;

    function anhaengen(adresse) {
      var url = new URL(adresse, location.origin);
      Object.keys(uebergabe).forEach(function (k) { url.searchParams.set(k, uebergabe[k]); });
      return url.toString();
    }

    document.querySelectorAll('.calendly-inline-widget[data-url]').forEach(function (el) {
      el.setAttribute('data-url', anhaengen(el.getAttribute('data-url')));
    });
    document.querySelectorAll('a[href*="calendly.com"]').forEach(function (a) {
      a.href = anhaengen(a.href);
    });
  }

  anwenden();
  document.addEventListener('visitorConsentCollected', anwenden);

  /* Gebuchter Termin -> Shopify-Kundenereignis `gb_termin_gebucht` (12.10.2026).
     Das benutzerdefinierte Pixel „GIESBER Termin an Meta" (Shopify > Kundenereignisse)
     hoert darauf und sendet an Meta das Standard-Event `Schedule`. Consent regelt das Pixel.
     Calendly meldet die Buchung nur aus dem Inline-Widget per postMessage, nicht bei
     direkten calendly.com-Links (dafuer spaeter Webhook + Conversions API). */
  var gemeldet = {};
  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://calendly.com') return;
    if (!e.data || e.data.event !== 'calendly.event_scheduled') return;
    var p = e.data.payload || {};
    var termin = ((p.event && p.event.uri) || '').split('/').pop() || String(Date.now());
    if (gemeldet[termin]) return;
    gemeldet[termin] = true;
    try {
      window.Shopify.analytics.publish('gb_termin_gebucht', {
        termin_id: termin,
        seite: location.pathname,
        utm_source: daten.utm_source || '',
        utm_campaign: daten.utm_campaign || '',
        utm_content: daten.utm_content || ''
      });
    } catch (err) { /* Shopify-Analytics nicht verfuegbar: Buchung bleibt in Calendly */ }
  });
})();
